import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneairportcabsedanservice() {



  const cardData = {




keyword: "Pune Airport Cab Sedan Service",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune Airport Cab Sedan Service for passengers traveling to and from Pune Airport for business trips, family travel, holidays, hotel transfers, railway station connections, and onward journeys. Our chauffeur-driven sedans are suitable for individuals, couples, and small families looking for a convenient airport transfer with comfortable seating and practical luggage space. Customers can book airport pickup and drop services with flexible timings, doorstep pickup, flight schedule coordination, professional drivers, clean vehicles, transparent pricing, and 24/7 customer assistance. Garud Cab Service also provides sedan transportation from Pune Airport to nearby business hubs, residential areas, hotels, and popular destinations across Maharashtra.",

topPlaces: [
  {
    title: "Kalyani Nagar",
    description: "Kalyani Nagar is a well-connected Pune locality known for premium residences, hotels, restaurants, offices, and commercial establishments. Passengers arriving at Pune Airport can book a sedan for a convenient and direct transfer to this area. Garud Cab Service provides professional airport pickup and drop facilities with comfortable seating, luggage space, and flexible scheduling according to flight timings."
  },
  {
    title: "Magarpatta City",
    description: "Magarpatta City is a major integrated residential and business development in Pune, attracting corporate employees, business travelers, and visitors staying in nearby hotels. A sedan airport cab is a convenient choice for passengers traveling between Pune Airport and Magarpatta. Customers can arrange scheduled pickup and drop services with professional chauffeurs and doorstep transportation."
  },
  {
    title: "Kharadi",
    description: "Kharadi is one of Pune's important IT and business destinations, with numerous offices, technology companies, residential communities, and hotels. Business travelers frequently require dependable airport transportation between Kharadi and Pune Airport. Garud Cab Service offers chauffeur-driven sedan transfers with flexible pickup locations and luggage-friendly travel for individuals and small groups."
  },
  {
    title: "Baner",
    description: "Baner is a prominent Pune neighborhood with IT offices, restaurants, hotels, residential developments, and commercial establishments. Travelers arriving at Pune Airport can choose a private sedan for a comfortable transfer to Baner without changing vehicles. The service is suitable for corporate passengers, families, and individuals requiring timely airport pickup or drop arrangements."
  },
  {
    title: "Wakad",
    description: "Wakad is a busy residential and commercial area in western Pune and provides convenient access toward Hinjawadi and the Mumbai-Pune Expressway. Passengers traveling from Pune Airport to Wakad can book a private sedan for direct transportation with convenient luggage space. Garud Cab Service provides flexible airport transfers for business travelers, families, and visitors."
  },
  {
    title: "Hinjawadi",
    description: "Hinjawadi is one of Pune's major technology and corporate hubs, hosting numerous IT companies, business parks, offices, and hotels. Airport transfers are frequently required by executives, employees, and visiting professionals. A chauffeur-driven sedan offers a comfortable option for traveling between Pune Airport and Hinjawadi, with pickup scheduling based on flight arrival and departure times."
  },
  {
    title: "Hadapsar",
    description: "Hadapsar is a major Pune locality with residential communities, commercial developments, offices, shopping areas, and business parks. Travelers arriving at Pune Airport can use a sedan cab for a direct and comfortable journey to Hadapsar. Customers can pre-book airport pickup and drop services with professional drivers and convenient doorstep transportation."
  },
  {
    title: "Shivajinagar",
    description: "Shivajinagar is a central Pune area known for offices, educational institutions, hotels, commercial markets, and major transportation connections. A sedan is suitable for airport passengers traveling with limited or moderate luggage who want private door-to-door transportation. Garud Cab Service offers convenient Pune Airport transfers with flexible scheduling and professional chauffeur service."
  },
  {
    title: "Deccan Gymkhana",
    description: "Deccan Gymkhana is a well-established central Pune locality featuring educational institutions, hotels, restaurants, shopping areas, and residential neighborhoods. Visitors and residents traveling to Pune Airport can book a private sedan for a smooth airport transfer. The service is suitable for early-morning departures, late-night arrivals, business travel, and family journeys."
  },
  {
    title: "Pimpri Chinchwad",
    description: "Pimpri Chinchwad is a major industrial, residential, and commercial region located in the northern part of the Pune metropolitan area. Travelers frequently require airport transportation for corporate visits, factory work, family travel, and onward journeys. Garud Cab Service provides comfortable sedan airport transfers between Pune Airport and Pimpri Chinchwad with flexible pickup and drop arrangements."
  }
],




"services": [
{
"name": "Pune Airport Cab Service",
"description": "Book Pune Airport Cab Service for comfortable and reliable airport transportation with professional chauffeurs and well-maintained air-conditioned vehicles. The service is suitable for airport pickups, airport drops, business travelers, families, tourists, individuals, and passengers requiring convenient transfers to or from Pune Airport."
},
{
"name": "Pune Airport Taxi",
"description": "Choose Pune Airport Taxi for convenient private transportation to or from Pune Airport with scheduled pickup and direct destination drop. Enjoy comfortable AC seating, professional chauffeur service, practical luggage space, and flexible travel arrangements for individuals, families, corporate travelers, and tourists."
},
{
"name": "Pune Airport Pickup Cab",
"description": "Reserve Pune Airport Pickup Cab for a convenient airport arrival transfer with professional chauffeur service and comfortable AC vehicles. Pickup can be arranged according to your travel schedule, making the service suitable for families, business passengers, tourists, and individuals arriving at Pune Airport."
},
{
"name": "Pune Airport Drop Taxi",
"description": "Book Pune Airport Drop Taxi for a comfortable and timely transfer from your home, hotel, office, or preferred location to Pune Airport. Enjoy private AC transportation, convenient pickup arrangements, professional chauffeur service, and suitable sedan options for passengers with luggage."
},
{
"name": "Sedan Taxi Pune Airport",
"description": "Choose Sedan Taxi Pune Airport for practical and comfortable airport transportation in an air-conditioned sedan. The service is suitable for individuals, couples, small families, corporate passengers, and tourists requiring convenient pickup or drop facilities with professional chauffeur service."
},
{
"name": "Airport Transfer Cab Pune",
"description": "Book Airport Transfer Cab Pune for dependable transportation between Pune Airport and your preferred home, hotel, office, railway station, or destination. Enjoy comfortable AC travel, scheduled pickup, professional chauffeurs, luggage-friendly seating, and convenient private transportation."
},
{
"name": "Pune Airport Car Rental",
"description": "Choose Pune Airport Car Rental with a professional chauffeur for convenient airport and city transportation. Select a comfortable sedan according to your passenger and luggage requirements for airport pickups, drops, business meetings, hotel transfers, sightseeing, and onward travel."
},
{
"name": "Airport Cab Booking Pune",
"description": "Make Airport Cab Booking Pune for scheduled airport transportation with convenient pickup and direct destination drop. Reserve a suitable AC vehicle according to your travel timing, passenger count, and luggage requirements for reliable airport transfers, business travel, family journeys, and tourist transportation."
},
{
"name": "Pune Airport Travel Service",
"description": "Choose Pune Airport Travel Service for comfortable private transportation to and from Pune Airport with professional chauffeurs and well-maintained AC vehicles. The service is suitable for airport transfers, business travel, family trips, hotel transportation, tourist arrivals, and onward outstation journeys."
},
{
"name": "Airport Sedan Cab Pune",
"description": "Book Airport Sedan Cab Pune for convenient airport pickup and drop transportation in a comfortable air-conditioned sedan. Enjoy professional chauffeur service, practical luggage space, scheduled travel, and private door-to-door transfers suitable for individuals, families, corporate passengers, and tourists."
},
{
"name": "Pune Outstation Cab Service",
"description": "Choose Pune Outstation Cab Service for comfortable chauffeur-driven transportation from Pune to destinations across Maharashtra and other cities. Sedan options provide AC interiors, comfortable seating, luggage space, and flexible one-way or round-trip arrangements for families, tourists, business travelers, and groups."
},
{
"name": "Pune to Mumbai Sedan Cab",
"description": "Book Pune to Mumbai Sedan Cab for a comfortable intercity journey with professional chauffeur service and a well-maintained AC sedan. The service is suitable for airport transfers, business travel, family visits, personal journeys, and one-way or round-trip transportation between Pune and Mumbai."
},
{
"name": "Pune to Nashik Sedan Cab",
"description": "Choose Pune to Nashik Sedan Cab for convenient private transportation with comfortable AC seating, practical luggage capacity, and an experienced chauffeur. The service is suitable for families, business travelers, tourists, religious trips, personal visits, and one-way or round-trip journeys."
},
{
"name": "Pune to Shirdi Sedan Cab",
"description": "Reserve Pune to Shirdi Sedan Cab for a comfortable pilgrimage journey with professional chauffeur service and private AC transportation. The sedan is suitable for Sai Baba devotees, families, senior passengers, couples, and small groups planning one-way, round-trip, or darshan travel from Pune."
},
{
"name": "Pune to Mahabaleshwar Sedan Cab",
"description": "Book Pune to Mahabaleshwar Sedan Cab for a comfortable hill-station journey with an experienced chauffeur and clean AC vehicle. The service is suitable for families, couples, tourists, weekend travelers, sightseeing trips, hotel transfers, and private one-way or round-trip travel."
},
{
"name": "Pune Intercity Taxi Service",
"description": "Choose Pune Intercity Taxi Service for reliable private transportation between Pune and major cities and tourist destinations. Enjoy professional chauffeur service, comfortable AC sedan travel, convenient pickup, practical luggage space, and flexible one-way or round-trip options for personal, family, corporate, and tourist journeys."
},
{
"name": "Sedan Taxi for Outstation Travel",
"description": "Book Sedan Taxi for Outstation Travel from Pune for comfortable long-distance transportation with professional chauffeur service. The air-conditioned sedan is suitable for individuals, couples, families, corporate travelers, and small groups planning one-way transfers, round trips, sightseeing, and personal journeys."
},
{
"name": "Pune Long Route Cab Service",
"description": "Choose Pune Long Route Cab Service for comfortable and dependable long-distance transportation with experienced chauffeurs and well-maintained AC sedans. The service is suitable for intercity travel, family journeys, business trips, pilgrimage travel, tourist routes, one-way drops, and extended round-trip journeys."
},
{
"name": "One Way Sedan Taxi Pune",
"description": "Book One Way Sedan Taxi Pune for direct point-to-point transportation without arranging a return journey. Enjoy comfortable AC travel, professional chauffeur service, convenient pickup, luggage space, and suitable sedan options for airport transfers, intercity travel, outstation trips, and personal journeys."
},
{
"name": "Outstation Taxi Booking Pune",
"description": "Make Outstation Taxi Booking Pune for scheduled private transportation to destinations outside Pune. Select a comfortable AC sedan according to your passenger count and luggage requirements while enjoying professional chauffeur service and flexible one-way or round-trip arrangements for family, business, pilgrimage, and tourist travel."
},
{
"name": "Maruti Suzuki Dzire Airport Cab Pune",
"description": "Book Maruti Suzuki Dzire Airport Cab Pune for economical and comfortable airport transportation with a professional chauffeur. The sedan offers AC interiors, comfortable seating, and practical luggage space for individuals, couples, small families, business passengers, and tourists traveling to or from Pune Airport."
},
{
"name": "Hyundai Aura Airport Taxi Pune",
"description": "Choose Hyundai Aura Airport Taxi Pune for convenient airport pickup and drop transportation in a comfortable air-conditioned sedan. Professional chauffeur service, practical luggage space, and scheduled transfers make the vehicle suitable for families, corporate passengers, tourists, and individual airport travelers."
},
{
"name": "Honda Amaze Outstation Cab Pune",
"description": "Reserve Honda Amaze Outstation Cab Pune for comfortable intercity and long-distance travel with an experienced chauffeur and AC interiors. The sedan is suitable for families, couples, corporate passengers, tourists, and individuals planning one-way or round-trip journeys from Pune."
},
{
"name": "Swift Dzire Airport Cab Pune",
"description": "Book Swift Dzire Airport Cab Pune for reliable and comfortable transportation to or from Pune Airport. Enjoy AC interiors, comfortable seating, practical luggage capacity, convenient pickup, and professional chauffeur service suitable for individuals, families, business travelers, and tourists."
},
{
"name": "Hyundai Aura Outstation Taxi Pune",
"description": "Choose Hyundai Aura Outstation Taxi Pune for comfortable chauffeur-driven travel to destinations outside Pune. The AC sedan provides practical seating and luggage space for families, couples, business travelers, tourists, and individuals planning one-way transfers, round trips, and long-distance journeys."
},
{
"name": "Sedan Cab for Pune Airport",
"description": "Book Sedan Cab for Pune Airport for convenient private transportation with scheduled pickup and direct airport drop or arrival transfer. Enjoy comfortable AC interiors, practical luggage space, and professional chauffeur service suitable for individuals, families, couples, corporate travelers, and tourists."
},
{
"name": "Sedan Taxi for Intercity Travel",
"description": "Choose Sedan Taxi for Intercity Travel from Pune for comfortable and convenient transportation between cities. Professional chauffeur service, AC interiors, comfortable seating, and practical luggage capacity make the sedan suitable for business travel, family visits, tourist journeys, airport transfers, and personal trips."
},
{
"name": "AC Sedan Cab Service Pune",
"description": "Book AC Sedan Cab Service Pune for comfortable chauffeur-driven transportation across the city, airport routes, and outstation destinations. Enjoy air-conditioned interiors, convenient pickup, professional drivers, and flexible travel arrangements for individuals, families, corporate passengers, tourists, and small groups."
},
{
"name": "Executive Sedan Cab Pune",
"description": "Choose Executive Sedan Cab Pune for comfortable and professional transportation suitable for business meetings, corporate travel, airport transfers, hotel transportation, and intercity journeys. Enjoy a clean AC sedan, comfortable seating, practical luggage space, and experienced chauffeur service."
},
{
"name": "Budget Sedan Taxi Pune",
"description": "Book Budget Sedan Taxi Pune for practical and comfortable private transportation at an economical vehicle option. The AC sedan is suitable for local rides, airport transfers, outstation journeys, family travel, business trips, sightseeing, and one-way or round-trip transportation."
},
{
"name": "Pune Airport Cab Sedan Service",
"description": "Reserve Pune Airport Cab Sedan Service for convenient airport pickup and drop transportation in a comfortable AC sedan. Enjoy scheduled transfers, professional chauffeur service, practical luggage space, and private door-to-door travel for individuals, families, corporate passengers, and tourists."
},
{
"name": "Pune Airport Sedan Cab",
"description": "Choose Pune Airport Sedan Cab for comfortable and dependable transportation to or from Pune Airport. The sedan provides AC interiors, comfortable seating, practical luggage capacity, and professional chauffeur service for airport arrivals, departures, business travel, family trips, and tourist journeys."
},
{
"name": "Pune Airport Taxi Service",
"description": "Book Pune Airport Taxi Service for reliable airport transportation with convenient pickup and direct destination drop. Professional chauffeurs provide comfortable AC travel and luggage-friendly seating for individuals, families, corporate travelers, tourists, and passengers requiring scheduled airport transfers."
},
{
"name": "Pune Airport Cab Booking",
"description": "Make Pune Airport Cab Booking for scheduled and private airport transportation with convenient pickup arrangements. Select a comfortable sedan according to passenger count and luggage requirements for airport pickup, airport drop, hotel transfers, business travel, and onward journeys."
},
{
"name": "Pune Airport Pickup and Drop Cab",
"description": "Book Pune Airport Pickup and Drop Cab for convenient two-way airport transportation with scheduled pickup and direct destination drop. Enjoy private AC travel, professional chauffeur service, practical luggage space, and flexible arrangements for families, individuals, corporate travelers, and tourists."
},
{
"name": "Pune to Outstation Sedan Cab",
"description": "Choose Pune to Outstation Sedan Cab for comfortable private transportation to destinations outside Pune. Enjoy professional chauffeur service, AC interiors, comfortable seating, and practical luggage space with flexible one-way and round-trip options for families, business travelers, tourists, and personal journeys."
},
{
"name": "Outstation Sedan Cab Pune",
"description": "Book Outstation Sedan Cab Pune for reliable long-distance travel with an experienced chauffeur and well-maintained air-conditioned sedan. The service is suitable for one-way transfers, round trips, family travel, corporate journeys, pilgrimage trips, sightseeing, and intercity transportation."
},
{
"name": "Pune Outstation Taxi Service",
"description": "Choose Pune Outstation Taxi Service for comfortable chauffeur-driven transportation to nearby cities, tourist destinations, pilgrimage locations, and other outstation routes. Sedan options provide AC comfort, luggage space, convenient pickup, and flexible travel arrangements for one-way and return journeys."
},
{
"name": "Sedan Cab for Outstation Pune",
"description": "Reserve Sedan Cab for Outstation Pune for convenient private travel with a professional chauffeur and comfortable AC vehicle. The sedan is suitable for families, couples, business travelers, tourists, and individuals planning long-distance journeys, airport transfers, sightseeing, one-way drops, and round trips."
},
{
"name": "Pune One Way Outstation Cab",
"description": "Book Pune One Way Outstation Cab for a direct point-to-point journey from Pune without arranging return transportation. Enjoy comfortable AC sedan travel, professional chauffeur service, convenient pickup, practical luggage space, and flexible routes for intercity, airport, family, business, and tourist travel."
}
],
"tableData": [
["Pune Airport Cab Service", "Pune Airport Taxi"],
["Pune Airport Pickup Cab", "Pune Airport Drop Taxi"],
["Sedan Taxi Pune Airport", "Airport Transfer Cab Pune"],
["Pune Airport Car Rental", "Airport Cab Booking Pune"],
["Pune Airport Travel Service", "Airport Sedan Cab Pune"],
["Pune Outstation Cab Service", "Pune to Mumbai Sedan Cab"],
["Pune to Nashik Sedan Cab", "Pune to Shirdi Sedan Cab"],
["Pune to Mahabaleshwar Sedan Cab", "Pune Intercity Taxi Service"],
["Sedan Taxi for Outstation Travel", "Pune Long Route Cab Service"],
["One Way Sedan Taxi Pune", "Outstation Taxi Booking Pune"],
["Maruti Suzuki Dzire Airport Cab Pune", "Hyundai Aura Airport Taxi Pune"],
["Honda Amaze Outstation Cab Pune", "Swift Dzire Airport Cab Pune"],
["Hyundai Aura Outstation Taxi Pune", "Sedan Cab for Pune Airport"],
["Sedan Taxi for Intercity Travel", "AC Sedan Cab Service Pune"],
["Executive Sedan Cab Pune", "Budget Sedan Taxi Pune"],
["Pune Airport Cab Sedan Service", "Pune Airport Sedan Cab"],
["Pune Airport Taxi Service", "Pune Airport Cab Booking"],
["Pune Airport Pickup and Drop Cab", "Pune to Outstation Sedan Cab"],
["Outstation Sedan Cab Pune", "Pune Outstation Taxi Service"],
["Sedan Cab for Outstation Pune", "Pune One Way Outstation Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Pune Airport Cab Sedan Service for Hassle-Free Transfers",
    WhyChoosedescription: "Garud Cab Service provides dependable sedan transportation to and from Pune Airport for business travellers, families, couples, tourists, and individuals who prefer a private and comfortable airport transfer."
  },
  {
    WhyChooseheading: "Airport Pickup & Drop at Your Preferred Time",
    WhyChoosedescription: "Schedule a sedan for airport pickup or drop according to your flight timing, with transportation arranged from your home, hotel, office, railway station area, or another convenient location."
  },
  {
    WhyChooseheading: "Comfortable Travel with Luggage Space",
    WhyChoosedescription: "A sedan offers a practical combination of comfortable passenger seating and boot space, making it suitable for travellers carrying cabin bags, suitcases, and personal luggage."
  },
  {
    WhyChooseheading: "Useful for Business Travellers",
    WhyChooseheading: "Useful for Business Travellers",
    WhyChoosedescription: "Corporate passengers can use the airport sedan service for office transfers, client pickups, meetings, hotel transportation, conferences, and business travel requiring punctual and private mobility."
  },
  {
    WhyChooseheading: "Available for Early-Morning & Late-Night Flights",
    WhyChoosedescription: "Airport transportation can be planned around your scheduled flight time, making the service useful for early departures, late arrivals, and other flight schedules."
  },
  {
    WhyChooseheading: "Direct Door-to-Airport Transportation",
    WhyChoosedescription: "Avoid unnecessary transfers by travelling directly from your selected Pune location to the airport or from the airport to your home, hotel, office, or destination."
  },
  {
    WhyChooseheading: "Suitable for Families & Small Groups",
    WhyChoosedescription: "Families and small groups can choose a sedan when they need a private airport transfer with comfortable seating and suitable luggage capacity."
  },
  {
    WhyChooseheading: "Simple Airport Booking with Garud",
    WhyChoosedescription: "Provide your pickup or drop location, flight date and time, passenger count, luggage details, and preferred travel arrangement to book a Pune Airport sedan with Garud Cab Service."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune Airport Sedan Service?",
    answer: "Yes, Garud Cab Service provides sedan cab services for Pune Airport pickup and drop, including transportation for individuals, families, couples, and corporate travellers."
  },
  {
    question: "Can I book a sedan for Pune Airport pickup?",
    answer: "Yes, sedan pickup can be arranged from Pune Airport to your home, hotel, office, railway station area, or another preferred destination."
  },
  {
    question: "Can I book a sedan for Pune Airport drop?",
    answer: "Yes, you can arrange a sedan from your home, hotel, office, or another Pune location to Pune Airport according to your flight schedule."
  },
  {
    question: "Is Pune Airport sedan service available for early flights?",
    answer: "Yes, airport cab arrangements can be planned around early-morning departures and other scheduled flight timings."
  },
  {
    question: "Can I book an airport cab for a late-night arrival?",
    answer: "Yes, sedan airport transportation can be scheduled according to your arrival time and preferred destination, subject to advance booking and availability."
  },
  {
    question: "Is a sedan suitable for passengers with luggage?",
    answer: "Yes, a sedan is a practical option for individuals, couples, and small families travelling with a reasonable amount of luggage."
  },
  {
    question: "Can corporate travellers use Pune Airport sedan service?",
    answer: "Yes, business travellers can use the service for airport transfers, client pickups, hotel transfers, office visits, meetings, and corporate travel."
  },
  {
    question: "Can families book a private airport sedan?",
    answer: "Yes, families can book a dedicated sedan according to their passenger count and luggage requirements."
  },
  {
    question: "Can I get pickup from my hotel in Pune?",
    answer: "Yes, pickup can be arranged from hotels, homes, offices, residential societies, railway station areas, and other convenient locations in Pune."
  },
  {
    question: "How can I book a Pune Airport Cab Sedan?",
    answer: "Share your pickup or drop location, flight date and time, passenger details, luggage requirement, and preferred sedan arrangement with Garud Cab Service to confirm your airport transfer."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Harsh Vaidya",
    feedback: "I booked a sedan for an early Pune Airport drop. The private pickup arrangement was convenient and made it easier to plan my journey around the flight timing.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neelam Joshi",
    feedback: "Our family used a sedan for Pune Airport pickup after returning from a trip. The vehicle was comfortable and had suitable space for our luggage.",
    rating: 5
  }
];







  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Airport Cab Sedan Service",
  "image": "https://garudcabs.com/assets/images/pune-airport-cab-sedan-service.webp",
  "description": "Book Pune Airport Cab Sedan Service with Garud Cab for safe, comfortable, and reliable airport transfers. Get Sedan taxi services for Pune Airport pickup and drop, airport transfers, car rental, and outstation journeys. Suitable for Pune to Mumbai, Nashik, Shirdi, and other intercity routes with convenient booking and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-airport-cab-sedan-service"
  }
};





  return (
    <div>



<Helmet>
  <title>Pune Airport Cab Sedan Service | Pickup & Drop Taxi | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune Airport Cab Sedan Service with Garud Cab for reliable airport pickup, drop, and transfer services. Get Sedan taxi, airport car rental, and outstation cab options for Mumbai, Nashik, Shirdi, and other routes."
  />

  <meta
    name="keywords"
    content="Pune Airport Cab Service, Pune Airport Taxi, Pune Airport Pickup Cab, Pune Airport Drop Taxi, Sedan Taxi Pune Airport, Airport Transfer Cab Pune, Pune Airport Car Rental, Airport Cab Booking Pune, Pune Airport Travel Service, Airport Sedan Cab Pune, Pune Outstation Cab Service, Pune to Mumbai Sedan Cab, Pune to Nashik Sedan Cab, Pune to Shirdi Sedan Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneairportcabsedanservice;